export enum MovingState {
  NONE = 'none',
  DOWN ='down',
  UP = 'up',
  UNKNOWN = 'unknown'
};

export enum LoadState {
  NORMAL = 'normal',
  FULL ='full',
  OVERLOAD = 'overload',
  UNKNOWN = 'unknown'
};
export enum CallStatus {
  CREATED = 'created',
  APPROVED ='approved',
  SERVED = 'served',
  CANCELLED = 'cancelled',
  TIMEOUT = 'timeout'
};

export interface Area {
  id: string;
  name: string;
}

export interface Lift {
  id: string;
  name?: string;
  movingState: MovingState;
  currentArea?: Area;
  currentLevelMillimeters?: number;
  loadState?: LoadState;
}

export interface DataIn {
  lift?: Lift,
  callStatus?: CallStatus,
  callableAreas?: Area[],
  connection: boolean;
  error?: string;
}